import React from "react";
import { useMediaQuery } from "@mui/material";
import { getDuration, formatMonthYear } from "../../../utils/utilities";
import ProgressBar from "../../../components/common/ProgressBar";
import { ReactComponent as MapIcon } from "../../../assets/icons/Views/dashboard/test-detail/map.svg";
import { ReactComponent as MailIcon } from "../../../assets/icons/Views/dashboard/test-detail/mail.svg";
import { ReactComponent as PhoneIcon } from "../../../assets/icons/Views/dashboard/test-detail/phone.svg";
import { ReactComponent as GithubIcon } from "../../../assets/icons/Views/dashboard/test-detail/github.svg";
import { ReactComponent as LinkedInIcon } from "../../../assets/icons/Views/dashboard/test-detail/linkedin.svg";
import { ReactComponent as CheckIcon } from "../../../assets/icons/Views/dashboard/test-detail/check-circle.svg";
import { ReactComponent as PortfolioIcon } from "../../../assets/icons/Views/dashboard/test-detail/portfolio.svg";
import { ReactComponent as AlertIcon } from "../../../assets/icons/Views/dashboard/test-detail/alert-triangle2.svg";
import { ReactComponent as ExternalLinkIcon } from "../../../assets/icons/Views/dashboard/test-detail/external-link.svg";

export default function ResumeInsightDetails(props) {
  const { assessment } = props;
  const isOnWebScreen = useMediaQuery("(min-width:1280px)");
  const recruiterInsights = assessment?.recruiter_insights;
  const parsedResume = assessment?.parsed_resume;

  return (
    <div className="w-100 d-flex flex-column" style={{ gap: "24px" }}>
      <div
        className="w-100 d-flex flex-column"
        style={{
          paddingBottom: "24px",
          borderBottom: "1px solid #ecedf1",
          gap: "8px",
        }}
      >
        <div
          className="w-100 d-flex flex-row align-items-center justify-content-between"
          style={{ gap: "24px" }}
        >
          <span className="subtitle-2 dark-100">
            {parsedResume?.candidate_profile?.name}
          </span>
          <div
            className="d-flex flex-row align-items-center"
            style={{ gap: "12px" }}
          >
            <span className="body-2 dark-50">
              {parsedResume?.candidate_profile?.email}
            </span>
            <MailIcon />
          </div>
        </div>
        <div
          className="w-100 d-flex flex-row align-items-center justify-content-between"
          style={{ gap: "24px" }}
        >
          <div
            className="d-flex flex-row align-items-center"
            style={{ gap: "12px" }}
          >
            <MapIcon />
            <span className="body-2 dark-50">
              {parsedResume?.candidate_profile?.location}
            </span>
          </div>
          <div
            className="d-flex flex-row align-items-center"
            style={{ gap: "12px" }}
          >
            <span className="body-2 dark-50">
              {parsedResume?.candidate_profile?.phone}
            </span>
            <PhoneIcon />
          </div>
        </div>
      </div>
      <div
        className="d-flex flex-row align-items-center justify-content-center"
        style={{ gap: "120px" }}
      >
        {parsedResume?.candidate_profile?.linkedin_url !== "null" &&
          parsedResume?.candidate_profile?.linkedin_url !== "" && (
            <a
              href={parsedResume?.candidate_profile?.linkedin_url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ cursor: "pointer" }}
            >
              <LinkedInIcon />
            </a>
          )}
        {parsedResume?.candidate_profile?.github_url !== "null" &&
          parsedResume?.candidate_profile?.github_url !== "" && (
            <a
              href={parsedResume?.candidate_profile?.github_url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ cursor: "pointer" }}
            >
              <GithubIcon />
            </a>
          )}
        {parsedResume?.candidate_profile?.portfolio_url !== "null" &&
          parsedResume?.candidate_profile?.portfolio_url !== "" && (
            <a
              href={parsedResume?.candidate_profile?.portfolio_url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ cursor: "pointer" }}
            >
              <PortfolioIcon />
            </a>
          )}
      </div>
      <div className="assessment-result-card-main-container">
        <div
          className="w-100 d-flex flex-column align-items-start justify-content-between1"
          style={{ gap: "8px" }}
        >
          <span className="subtitle-2 dark-100">AI Summary</span>
          <span className="body-2 dark-100 text-start">
            {recruiterInsights?.ai_summary?.headline}
          </span>
        </div>
        <div className="w-100 d-flex flex-column" style={{ gap: "16px" }}>
          {/* Pros Section */}
          {recruiterInsights?.ai_summary?.pros && (
            <div
              className="d-flex flex-row align-items-start"
              style={{ gap: "12px" }}
            >
              <div
                className="d-flex flex-row align-items-center"
                style={{ gap: "8px", minWidth: "80px" }}
              >
                <CheckIcon />
                <span className="subtitle-2 dark-100">Pros:</span>
              </div>
              <div
                className="d-flex flex-row flex-wrap"
                style={{ gap: "12px" }}
              >
                {recruiterInsights?.ai_summary?.pros?.map((s, i) => {
                  return (
                    <div
                      key={i}
                      style={{
                        padding: "4px 12px",
                        background: "#E8F5E9",
                        borderRadius: "16px",
                      }}
                    >
                      <span className="body-2" style={{ color: "#4CAF50" }}>
                        {s}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          {/* Red Flags Section */}

          {recruiterInsights?.ai_summary?.red_flags && (
            <div
              className="d-flex flex-row align-items-start"
              style={{ gap: "12px" }}
            >
              <div
                className="d-flex flex-row align-items-center"
                style={{ gap: "8px", minWidth: "115px" }}
              >
                <AlertIcon width={16} height={16} />
                <span className="subtitle-2 dark-100">Red Flags:</span>
              </div>
              <div
                className="d-flex flex-row flex-wrap"
                style={{ gap: "12px" }}
              >
                {recruiterInsights?.ai_summary?.red_flags?.map((c, i) => {
                  return (
                    <div
                      key={i}
                      style={{
                        padding: "4px 12px",
                        background:
                          c.severity === "High" ? "#FFEBEE" : "#FFF3E0",
                        borderRadius: "16px",
                      }}
                    >
                      <span
                        className="body-2"
                        style={{
                          color: c.severity === "High" ? "#F44336" : "#FFB300",
                        }}
                      >
                        {c.message}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="assessment-result-card-main-container">
        <div
          className="w-100 d-flex flex-column align-items-start"
          style={{ gap: "16px" }}
        >
          {/* Role Alignment */}
          {recruiterInsights?.role_alignment && (
            <div
              className="w-100 d-flex flex-column align-items-start"
              style={{
                padding: "16px",
                background: "#F6F5F8",
                borderRadius: "12px",
                gap: "8px",
              }}
            >
              <div
                className="w-100 d-flex flex-row align-items-center"
                style={{
                  paddingBottom: "8px",
                  borderBottom: "1px solid #ecedf1",
                  gap: "8px",
                }}
              >
                <span className="subtitle-2 dark-100">Role Alignment</span>
                <span
                  className="body-2"
                  style={{
                    color:
                      recruiterInsights?.role_alignment?.match_level ===
                      "Strong Match"
                        ? "#4CAF50"
                        : recruiterInsights?.role_alignment?.match_level ===
                            "Moderate Match"
                          ? "#FFB300"
                          : "#F44336",
                  }}
                >
                  {recruiterInsights?.role_alignment?.match_level}
                </span>
              </div>
              <div
                className="w-100 d-flex flex-row align-items-center"
                style={{ gap: "12px" }}
              >
                <span
                  className="body-2 dark-50 medium"
                  // style={{ width: "120px" }}
                >
                  Previous Titles:{" "}
                </span>
                <div
                  className="d-flex flex-row flex-wrap"
                  style={{ width: "calc(100% - 120px)", gap: "8px" }}
                >
                  {recruiterInsights?.role_alignment?.previous_titles?.map(
                    (r, i) => (
                      <div
                        key={i}
                        style={{
                          padding: "4px 8px",
                          background: "#FFFFFF",
                          borderRadius: "16px",
                        }}
                      >
                        <span className="body-2 dark-50">{r}</span>
                      </div>
                    ),
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Skills Match */}
          {recruiterInsights?.skills_match && (
            <div
              className="w-100 d-flex flex-column"
              style={{
                padding: "16px",
                background: "#F6F5F8",
                borderRadius: "12px",
                gap: "8px",
              }}
            >
              <div
                className="w-100 d-flex flex-row align-items-center justify-content-between"
                style={{
                  paddingBottom: "8px",
                  borderBottom: "1px solid #ecedf1",
                  gap: "8px",
                }}
              >
                <div
                  className="d-flex flex-row align-items-center"
                  style={{ gap: "8px" }}
                >
                  <span className="subtitle-2 dark-100">Skills Match</span>
                  <span
                    className="body-2"
                    style={{
                      color:
                        recruiterInsights?.skills_match?.match_level ===
                        "Strong Match"
                          ? "#4CAF50"
                          : recruiterInsights?.skills_match?.match_level ===
                              "Moderate Match"
                            ? "#FFB300"
                            : "#F44336",
                    }}
                  >
                    {recruiterInsights?.skills_match?.match_level}
                  </span>
                </div>
                <span className="body-2 dark-50 medium">{`${recruiterInsights?.skills_match?.keywords_found?.length} keyword${recruiterInsights?.skills_match?.keywords_found?.length > 1 ? "s" : ""} found, ${recruiterInsights?.skills_match?.keywords_missing?.length} missing`}</span>
              </div>

              {recruiterInsights?.skills_match?.keywords_found && (
                <div
                  className="w-100 d-flex flex-row align-items-center"
                  style={{ gap: "12px" }}
                >
                  <span
                    className="body-2 dark-50 medium"
                    // style={{ width: "120px" }}
                  >
                    Keywords found:
                  </span>
                  <div
                    className="d-flex flex-row flex-wrap"
                    style={{ width: "calc(100% - 120px)", gap: "8px" }}
                  >
                    {recruiterInsights?.skills_match?.keywords_found.map(
                      (label) => (
                        <div
                          key={label}
                          style={{
                            padding: "4px 8px",
                            background: "#FFFFFF",
                            borderRadius: "16px",
                          }}
                        >
                          <span className="body-2 dark-50">{label}</span>
                        </div>
                      ),
                    )}
                  </div>
                </div>
              )}

              {recruiterInsights?.skills_match?.keywords_missing && (
                <div
                  className="d-flex flex-row align-items-center"
                  style={{ gap: "12px" }}
                >
                  <span
                    className="body-2 dark-50 medium"
                    // style={{ width: "120px" }}
                  >
                    Keywords Missing:
                  </span>
                  <div
                    className="d-flex flex-row flex-wrap"
                    style={{ width: "calc(100% - 128px)", gap: "8px" }}
                  >
                    {recruiterInsights?.skills_match?.keywords_missing.map(
                      (label) => (
                        <div
                          key={label}
                          style={{
                            padding: "4px 8px",
                            background: "#FFFFFF",
                            borderRadius: "16px",
                          }}
                        >
                          <span className="body-2 dark-50">{label}</span>
                        </div>
                      ),
                    )}
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Industry Alignment */}
          {recruiterInsights?.industry_alignment && (
            <div
              className="w-100 d-flex flex-column"
              style={{
                padding: "16px",
                background: "#F6F5F8",
                borderRadius: "12px",
                gap: "8px",
              }}
            >
              <div
                className="w-100 d-flex flex-row align-items-center"
                style={{
                  paddingBottom: "8px",
                  borderBottom: "1px solid #ecedf1",
                  gap: "8px",
                }}
              >
                <span className="subtitle-2 dark-100">Industry Alignment</span>
                <span
                  className="body-2"
                  style={{
                    color:
                      recruiterInsights?.industry_alignment?.match_level ===
                      "High Match"
                        ? "#4CAF50"
                        : recruiterInsights?.industry_alignment?.match_level ===
                            "Moderate Match"
                          ? "#FFB300"
                          : "#F44336",
                  }}
                >
                  {recruiterInsights?.industry_alignment?.match_level}
                </span>
              </div>
              <div
                className="w-100 d-flex flex-row align-items-center"
                style={{ gap: "12px" }}
              >
                <span className="body-2 dark-50 medium">
                  Previous Industries:
                </span>
                <div
                  className="d-flex flex-row flex-wrap"
                  style={{ width: "calc(100% - 128px)", gap: "8px" }}
                >
                  {recruiterInsights?.industry_alignment?.previous_industries?.map(
                    (label) => (
                      <div
                        key={label}
                        style={{
                          padding: "4px 8px",
                          background: "#FFFFFF",
                          borderRadius: "16px",
                        }}
                      >
                        <span className="body-2 dark-50">{label}</span>
                      </div>
                    ),
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Seniority Fit */}
          {recruiterInsights?.seniority_fit && (
            <div
              className="w-100 d-flex flex-column"
              style={{
                padding: "16px",
                background: "#F6F5F8",
                borderRadius: "12px",
                gap: "8px",
              }}
            >
              <div
                className="w-100 d-flex flex-row align-items-center"
                style={{
                  paddingBottom: "8px",
                  borderBottom: "1px solid #ecedf1",
                  gap: "8px",
                }}
              >
                <span className="subtitle-2 dark-100">Seniority Fit</span>
                <span
                  className="body-2"
                  style={{
                    color:
                      recruiterInsights?.seniority_fit?.fit ===
                      "Exceeds The Required Level"
                        ? "#4CAF50"
                        : recruiterInsights?.seniority_fit?.fit ===
                            "Meets The Required Level"
                          ? "#FFB300"
                          : "#F44336",
                  }}
                >
                  {recruiterInsights?.seniority_fit?.fit}
                </span>
              </div>
              <div
                className="d-flex flex-row align-items-start justify-content-between"
                style={{ gap: "24px" }}
              >
                <span className="body-2 dark-50 medium">
                  Level:{" "}
                  <span className="normal">
                    {recruiterInsights?.seniority_fit?.level}
                  </span>
                </span>
                <span className="body-2 dark-50 medium">
                  Total Experience:{" "}
                  <span className="normal">
                    {recruiterInsights?.seniority_fit?.total_experience_years}{" "}
                    {recruiterInsights?.seniority_fit?.total_experience_years <=
                    1
                      ? "Year"
                      : "Years"}
                  </span>
                </span>
              </div>
            </div>
          )}

          {/* Keyword Match Density */}
          {recruiterInsights?.keyword_match_density && (
            <div
              className="w-100 d-flex flex-row align-items-center justify-content-between"
              style={{
                padding: "16px",
                background: "#F6F5F8",
                borderRadius: "12px",
                gap: "12px",
              }}
            >
              <span className="subtitle-2 dark-100 text-start">
                Keyword Match Density (ATS-style)
              </span>
              <span className="body-2 dark-50 text-start">
                Matched Keywords:{" "}
                {recruiterInsights?.keyword_match_density?.matched}/
                {recruiterInsights?.keyword_match_density?.total}
              </span>
            </div>
          )}

          {/* Tenure Stability */}
          {recruiterInsights?.tenure_stability && (
            <div
              className="w-100 d-flex flex-row align-items-center justify-content-between"
              style={{
                padding: "16px",
                background: "#F6F5F8",
                borderRadius: "12px",
                gap: "12px",
              }}
            >
              <div
                className="d-flex flex-row align-items-center"
                style={{ gap: "8px" }}
              >
                <span className="subtitle-2 dark-100">Tenure Stability</span>
                <span
                  className="body-2"
                  style={{
                    color:
                      recruiterInsights?.tenure_stability?.label === "Stable"
                        ? "#4CAF50"
                        : recruiterInsights?.tenure_stability?.label ===
                            "Moderate"
                          ? "#FFB300"
                          : "#F44336",
                  }}
                >
                  {recruiterInsights?.tenure_stability?.label}
                </span>
              </div>
              <span className="body-2 dark-50">
                Avg: {recruiterInsights?.tenure_stability?.avg_years_per_role}{" "}
                {recruiterInsights?.tenure_stability?.avg_years_per_role <= 1
                  ? "Year/Role"
                  : "Years/Role"}
              </span>
            </div>
          )}

          {/* Qualifying Question */}
          {recruiterInsights?.qualifying_question_assessment && (
            <div
              className="w-100 d-flex flex-row align-items-center"
              style={{
                padding: "16px",
                background: "#F6F5F8",
                borderRadius: "12px",
                gap: "8px",
              }}
            >
              <span className="subtitle-2 dark-100">Qualifying Question</span>
              <span className="body-2" style={{ color: "#FBC02D" }}>
                {recruiterInsights?.qualifying_question_assessment?.status}
              </span>
            </div>
          )}
        </div>
      </div>

      {/* Experience Section */}
      {parsedResume?.experience?.length != 0 && (
        <div className="assessment-result-card-main-container">
          <div
            className="w-100 d-flex flex-column align-items-start"
            style={{ gap: "16px" }}
          >
            <span className="subtitle-2 dark-100">Experience</span>
            <div className="w-100 d-flex flex-column" style={{ gap: "16px" }}>
              {parsedResume?.experience?.map((exp, index) => (
                <div
                  key={index}
                  className="d-flex flex-column"
                  style={{
                    padding: "16px",
                    background: "#F6F5F8",
                    borderRadius: "12px",
                    gap: "12px",
                  }}
                >
                  {/* Header: Role, Company, Date */}
                  <div className="d-flex flex-row align-items-center justify-content-between flex-wrap">
                    <div
                      className="d-flex flex-row align-items-start"
                      style={{ gap: "4px" }}
                    >
                      <span className="subtitle-2 dark-100 text-start">
                        {exp.title}
                      </span>
                      <span
                        className="subtitle-2 text-start"
                        style={{ color: "#7B61FF" }}
                      >
                        @{exp.company}
                      </span>
                    </div>
                    {((exp?.start_date !== "null" && exp?.start_date !== "") ||
                      (exp?.end_date !== "null" && exp?.end_date !== "")) && (
                      <span className="caption dark-50">
                        {`${formatMonthYear(exp?.start_date)} - ${exp?.end_date === "PRESENT" ? "Present" : formatMonthYear(exp?.end_date)}`}
                      </span>
                    )}
                  </div>

                  {/* Bullet Points */}
                  <div
                    className="d-flex flex-column align-items-start"
                    style={{ gap: "4px" }}
                  >
                    {exp?.bullets?.map((point, idx) => (
                      <div
                        key={idx}
                        className="d-flex flex-row align-items-start"
                        style={{ gap: "8px" }}
                      >
                        <span
                          className="body-1 dark-50 text-start"
                          style={{ minWidth: "4px" }}
                        >
                          ·
                        </span>
                        <span className="body-2 dark-50 text-start">
                          {point}
                        </span>
                      </div>
                    ))}
                  </div>

                  {/* Tags */}
                  {exp?.technologies?.length > 0 && (
                    <div
                      className="d-flex flex-row flex-wrap"
                      style={{ gap: "8px", marginTop: "4px" }}
                    >
                      {exp?.technologies?.map((tag, tIdx) => (
                        <div
                          key={tIdx}
                          style={{
                            padding: "4px 12px",
                            background: "#FFFFFF",
                            borderRadius: "16px",
                          }}
                        >
                          <span className="caption dark-50">{tag}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Education Section */}
      {parsedResume?.education?.length != 0 && (
        <div className="assessment-result-card-main-container">
          <div
            className="w-100 d-flex flex-column align-items-start"
            style={{ gap: "16px" }}
          >
            <span className="subtitle-2 dark-100">Education</span>
            <div className="w-100 d-flex flex-column" style={{ gap: "16px" }}>
              {parsedResume?.education?.map((edu, index) => (
                <div
                  key={index}
                  className="d-flex flex-column"
                  style={{
                    padding: "16px",
                    background: "#F6F5F8",
                    borderRadius: "12px",
                    gap: "12px",
                  }}
                >
                  {/* Header: Degree, Institution, Date */}
                  <div
                    className="w-100 d-flex flex-column align-items-start"
                    style={{ gap: "4px" }}
                  >
                    <div className="d-flex flex-row align-items-start justify-content-between flex-wrap">
                      <div
                        className="d-flex flex-row align-items-start"
                        style={{ gap: "4px" }}
                      >
                        <span className="subtitle-2 dark-100 text-start">
                          {edu?.degree}
                        </span>
                        <span
                          className="subtitle-2 text-start"
                          style={{ color: "#7B61FF" }}
                        >
                          @{edu?.institution}
                        </span>
                      </div>
                    </div>
                    <span className="caption dark-50">
                      {((edu?.start_date !== "null" &&
                        edu?.start_date !== "") ||
                        (edu?.end_date !== "null" && edu?.end_date !== "")) && (
                        <span className="caption dark-50">
                          {`${formatMonthYear(edu?.start_date)} - ${edu?.end_date === "PRESENT" ? "Present" : formatMonthYear(edu?.end_date)}`}
                        </span>
                      )}
                      {edu?.gpa !== null &&
                        edu?.gpa !== "" &&
                        edu?.gpa !== "null" && (
                          <span style={{ margin: "0 4px" }}>
                            CGPA: {edu?.gpa}
                          </span>
                        )}
                      {edu?.honors != null &&
                        edu?.honors != "" &&
                        edu?.honors != "null" && (
                          <span style={{ margin: "0 4px" }}>
                            -{" "}
                            <span style={{ color: "#4CAF50" }}>
                              {edu?.honors}
                            </span>
                          </span>
                        )}
                    </span>
                  </div>

                  {/* Courses */}
                  {/* {edu?.courses && edu?.courses?.length > 0 && (
                    <div
                      className="w-100 d-flex flex-row align-items-start"
                      style={{
                        gap: "12px",
                        marginTop: "4px",
                        borderTop: "1px solid #E0E0E0",
                        paddingTop: "12px",
                      }}
                    >
                      <span
                        className="body-2 dark-50"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        Relevant Courses
                      </span>
                      <div
                        className="d-flex flex-row flex-wrap"
                        style={{ gap: "8px" }}
                      >
                        {edu?.courses?.map((course, cIdx) => (
                          <div
                            key={cIdx}
                            style={{
                              padding: "4px 12px",
                              background: "#FFFFFF",
                              borderRadius: "16px",
                            }}
                          >
                            <span className="caption dark-50">{course}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )} */}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Certifications Section */}
      {parsedResume?.certifications?.length != 0 && (
        <div className="assessment-result-card-main-container">
          <div
            className="w-100 d-flex flex-column align-items-start"
            style={{ gap: "16px" }}
          >
            <span className="subtitle-2 dark-100">Certifications</span>
            <div className="w-100 d-flex flex-column" style={{ gap: "16px" }}>
              {parsedResume?.certifications?.map((cert, index) => (
                <div
                  key={index}
                  className="w-100 d-flex flex-row align-items-center justify-content-between"
                  style={{
                    padding: "16px 24px",
                    background: "#F6F5F8",
                    borderRadius: "100px",
                  }}
                >
                  <div
                    className="d-flex flex-row align-items-start"
                    style={{ width: "calc(100% - 100px)", gap: "8px" }}
                  >
                    <span className="subtitle-2 dark-100 text-start">
                      {cert.name}
                    </span>
                    {cert.credential_url !== "" &&
                      cert.credential_url !== "null" && (
                        <a
                          href={cert.credential_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ cursor: "pointer" }}
                        >
                          <ExternalLinkIcon />
                        </a>
                      )}
                  </div>
                  {cert?.issue_date !== "null" && cert?.issue_date !== "" && (
                    <span className="caption dark-50">
                      {formatMonthYear(cert?.issue_date)}
                    </span>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
      {/* <div className="assessment-result-card-main-container"></div> */}
    </div>
  );
}
